import React, { useContext, useState } from "react";
import { Box, Button, Grid, Paper, TextField } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

// Contexts
import DomainContext from "../../../context/domains/DomainContext";

// Components
import DomainAddBox from "./DomainAddBox";

const DomainAdd = ({ handleUpdate }) => {
  const useStyles = makeStyles(() => ({
    paper: {
      padding: 15,
    },
    alignCenter: {
      textAlign: "center",
    },
  }));
  const classes = useStyles();

  const {
    new_domain,
    setNewDomain,
    new_domain_error,
    setNewDomainError,
    createDomain,
    search_domain,
    filterDomains,
  } = useContext(DomainContext);

  const [open_add_box, setOpenAddBox] = useState(false);

  const closeAddBox = (indicator) => {
    setOpenAddBox(false);

    if (!indicator) {
      setNewDomain({ ...new_domain, project: "" });
    }
  };

  // Add Domain
  const add = async () => {
    // if (new_domain_error.name === "" && new_domain.name && new_domain.project) {
    if (new_domain_error.name === "" && new_domain.name) {
      closeAddBox("added");
      await createDomain();
      handleUpdate();
    }
  };

  // Open Add Box
  const handleAdd = (e) => {
    e.preventDefault();

    if (new_domain.name && new_domain_error.name === "") {
      setOpenAddBox(true);
    }
  };

  const filter = (e) => {
    const value = e.target.value.trim();
    filterDomains(value);
  };

  const clearSearch = () => {
    if (search_domain) {
      filterDomains("");
      handleUpdate();
    }
  };

  const handleChange = (e) => {
    const id = e.target.id;
    let value = e.target.value;

    if (id === "name") {
      setNewDomain({ ...new_domain, [id]: value.trim() });

      if (
        value.trim() &&
        (value.trim().includes("http") ||
          value.trim().includes(":") ||
          !value.trim().includes("www.") ||
          !(value.trim().includes(".com") ||
          value.trim().includes(".store")))
      ) {
        setNewDomainError({
          ...new_domain_error,
          [id]: "Invalid format. E.g: www.example.com, www.example.store",
        });
      } else {
        setNewDomainError({ ...new_domain_error, [id]: "" });
      }
    }
  };

  return (
    <Grid item>
      <DomainAddBox
        open_add_box={open_add_box}
        closeAddBox={closeAddBox}
        add={add}
      />
      <Box component="form" noValidate autoComplete="off" onSubmit={handleAdd}>
        <Paper className={classes.paper}>
          {" "}
          {/* Add Domain */}{" "}
          <Grid container alignItems="center" justifyContent="flex-start">
            <Grid item xs={10}>
              <TextField
                variant="outlined"
                margin="dense"
                size="small"
                fullWidth
                required
                id="name"
                placeholder="www.mywebsite.com"
                onChange={handleChange}
                value={new_domain.name}
                error={new_domain_error.name ? true : false}
                helperText={new_domain_error.name}
              />{" "}
            </Grid>
            <Grid item xs={2} className={classes.alignCenter}>
              <Button variant="contained" color="primary" type="submit">
                Add{" "}
              </Button>{" "}
            </Grid>{" "}
          </Grid>
          {/* Search Domain */}{" "}
          <Grid container alignItems="center" justifyContent="flex-start">
            <Grid item xs={10}>
              <TextField
                variant="outlined"
                margin="dense"
                size="small"
                fullWidth
                required
                id="search_domain"
                placeholder="search"
                value={search_domain}
                onChange={filter}
              />{" "}
            </Grid>
            <Grid item xs={2} className={classes.alignCenter}>
              <Button variant="outlined" color="primary" onClick={clearSearch}>
                Clear{" "}
              </Button>{" "}
            </Grid>{" "}
          </Grid>{" "}
        </Paper>{" "}
      </Box>{" "}
    </Grid>
  );
};

export default DomainAdd;
